import { NavLink, useLocation } from "react-router-dom";
import { useState } from "react";
import { Button, Stack } from "react-bootstrap";
import { Input, PinInput } from "rsuite";
import { useAuth } from "../../auth/Auth";

export default function TwoFAVerify() {
    const { onTwoFactorLogin } = useAuth();

    const location = useLocation();
    const [error, setError] = useState(null);

    const [backupCodeMode, setBackupCodeMode] = useState(false);
    const [backupCode, setBackupCode] = useState("");

    const onVerify = async value => {
        setError(await onTwoFactorLogin(value, location.state?.origin || "/"));
    };

    return (
        <Stack className=" justify-content-center align-items-start" gap={3}>
            <h1 className="text-light fw-bold lh-sm fs-2 text-center text-xl-start">Two-factor verification</h1>
            {backupCodeMode ? (
                <>
                    <span className="text-light">Lost access to authenticator app? Enter backup code</span>
                    <Stack direction="horizontal" gap={2}>
                        <Input size="lg" w={292} value={backupCode} onChange={setBackupCode} placeholder="Backup Code" />
                        <Button variant="ra-yellow" className="h-100 text-uppercase fw-bold" onClick={async () => await onVerify(backupCode)}>
                            Verify
                        </Button>
                    </Stack>
                    <Button variant="ra-yellow-outline" size="sm" onClick={() => setBackupCodeMode(false)}>
                        Found the authenticator app again?
                    </Button>
                </>
            ) : (
                <>
                    <span className="text-light">Enter 6-digit code from your authenticator app</span>
                    <PinInput size="lg" length={6} otp onComplete={onVerify} />
                    <Button variant="ra-yellow-outline" size="sm" onClick={() => setBackupCodeMode(true)}>
                        Lost Access to the authenticator app?
                    </Button>
                </>
            )}
            <div className="position-relative w-100">
                <span className="text-warning position-absolute">{error}</span>
            </div>
            <NavLink to={"/login"} end className="btn btn-ra-light text-uppercase fw-bold fs-5 btn-sm mt-3 px-5">
                Back to Login
            </NavLink>
        </Stack>
    );
}
